export const BUTTON_STYLE = {
  position: 'absolute', right: 25, top: 35, zIndex: 99999999999999,
} as any;
export const MAX_PARTICIPANT = 3;
